import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import SidePanelContainer from "../../components/SidePanelContainer";
import SidePanel from "../../components/SidePanel";
import THREEScene from "../../components/Renderer";
import { formatURL } from "../../utils/utils";
// Required Imports for 'Modal popup'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CardDeck from "react-bootstrap/CardDeck";
import Card from "react-bootstrap/Card";
import Loading from "../../components/Loading";

function DesignPage(props) {

  let allowPlace = props.designstep === 2 ? true : false;
  //console.log("DesignPage")

  // console.log("DesignPage :: " + props.designstep)
  return (
    <div className={props.sidebarActive ? "main-container" : "main-container expanded"}>
      <Modal show={props.orientationPopup} onHide={props.closePopup}>
        <Modal.Body>Het is aangeraden om uw scherm te draaien voor een betere ervaring.</Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={props.closePopup}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {props.designstep === 0 ?
        <div>
          <Container>
            <br />
            <Row>
              <h1>Kamertype Kiezen</h1>
            </Row>
            <Row>
              <p>Kies het type kast dat u wilt ontwerpen.</p>
            </Row>
            <Row>
              <CardDeck >
                {props.rooms.map(room => {
				  
				  const percentage = props.rooms.length > 3 ? (100 / (props.rooms.length / 2) - 5) + "%" : (100 / props.rooms.length - 5) + "%" 

                  return (
                    <Card
                      key={"room-" + room.room_id}
                      onClick={e => {
                        props.setRoom(room)
                      }}
					  ref={(el) => {
                        if (el) {
                          el.style.setProperty('flex-basis', percentage, 'important');
                        }
                      }}
                    >
                      <Card.Img variant="top" src={formatURL(room.room_thumbnail_path)} />
                      <br />
                      <Card.Text>{room.room_description}</Card.Text>
                      <Button>Kiezen</Button>
                    </Card>
                  )
                })}

              </CardDeck>
            </Row>
          </Container>
        </div>
        :
        <Container fluid>
          <Row noGutters style={{ paddingTop: ".5rem", paddingLeft: ".5rem" }}>
            <Col id='renderer-container'>
              <div className='scene-container'>
                <THREEScene
                  designstep={props.designstep}
                  room={props.currentRoom}
                  allowPlace={allowPlace}
                  boxDimensions={props.boxDimensions}
                  closetProps={props.closetProps}
                  updateSlots={props.updateSlots}
                  updateLoading={props.updateLoading}
                  updatePrice={props.calculatePrice}
                  updatePageState={props.updatePageState}
                  wallColor={props.wallColor}
                />
              </div>
              {props.loading ?
                <div className='module-loading'>
                  <Loading />
                </div>
                : null}

            </Col>
            <Col lg='3'>
              {/* <SidePanelContainer */}
              <SidePanel
                room={props.currentRoom}
                validationSizes={props.validationSizes}
                designstep={props.designstep}
                nextPage={() => { props.updateDesignStep(true) }}
                prevPage={() => { props.updateDesignStep(false) }}
                boxDimensions={props.boxDimensions}
                setBoxDimensions={props.setBoxDimensions}
                closetProps={props.closetProps}
                activeGrip={props.activeGrip}
                slots={props.slots}
                modules={props.modules}
                materials={props.materials}
                features={props.features}
                featureTypes={props.featureTypes}
                helps={props.helps}
                setActiveModule={props.setActiveModule}
                setActiveGrip={props.setActiveGrip}
                setInnerMaterial={props.setInnerMaterial}
                setOuterMaterial={props.setOuterMaterial}
                updatePrice={props.calculatePrice}
                generateOrderJSON={props.generateOrderJSON}
                closetProps={props.closetProps}
                submitOrder={props.submitOrder}
                totalPrice={props.totalPrice}
                formErrors={props.formErrors}
                clearCustomerFormErrors={props.clearCustomerFormErrors}
                wallColor={props.wallColor}
                setWallColor={props.setWallColor}
              />
            </Col>
          </Row>
        </Container>}
    </div>
  );
}

export default DesignPage;
